var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27 307.21v52.21c0 31.82 25 57.62 57 57.76v-8.555a58.411 58.411 0 0 1 -27-49.2v-52.215a58.4 58.4 0 0 1 27-49.2v-8.55c-32 .14-57 25.94-57 57.75z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m363.715 91.748a179.282 179.282 0 0 1 54.285 128.267v36.985h12v-36.985a191.3 191.3 0 0 0 -58.542-137.481 25.165 25.165 0 0 0 -7.549-31.342 209.642 209.642 0 0 0 -249.6 0 25.474 25.474 0 0 0 -7.669 31.336 191.462 191.462 0 0 0 -58.64 137.487v37.985h12v-37.985a179.431 179.431 0 0 1 54.383-128.265 25.31 25.31 0 0 0 14.933 4.885 25.017 25.017 0 0 0 14.912-4.927 159.374 159.374 0 0 1 189.728 0 25.038 25.038 0 0 0 29.759.04zm-226.6-9.681a13.078 13.078 0 0 1 -17.49-1.784 13.259 13.259 0 0 1 -3.394-10.2 12.933 12.933 0 0 1 5.221-9.251 197.635 197.635 0 0 1 235.3 0 12.932 12.932 0 0 1 5.221 9.25 13.262 13.262 0 0 1 -3.394 10.2 13.081 13.081 0 0 1 -17.491 1.784 171.306 171.306 0 0 0 -203.973 0z",
    fill: "#09588d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119 417.179v-167.72c0-3.313-2.82-6.459-6.134-6.459h-28.544c-35.154 0-63.322 29.059-63.322 64.214v52.21a63.306 63.306 0 0 0 63.322 63.576h28.544a5.966 5.966 0 0 0 6.134-5.821zm-86-57.755v-52.21c0-26.419 19-48.263 45-51.363v154.936c-26-3.1-45-24.944-45-51.363zm74 51.576h-17v-156h17z",
    fill: "#f86f4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.762 274.582a63.979 63.979 0 0 0 -54.874-31.582h-28.544a6.709 6.709 0 0 0 -6.344 6.459v167.72c0 3.313 3.03 5.821 6.344 5.821h11.656v18.66a32.588 32.588 0 0 1 -32.635 32.34h-58.365v-9.88a6.455 6.455 0 0 0 -6.4-6.12h-60.231a22 22 0 0 0 0 44h60.231c3.313 0 6.4-2.687 6.4-6v-10h58.365c24.482 0 44.635-19.858 44.635-44.34v-18.66h4.888a63.692 63.692 0 0 0 54.874-31.263 61.543 61.543 0 0 0 0-117.155zm-239.333 205.418a10 10 0 0 1 9.94-10h19.631v20h-19.631a10 10 0 0 1 -9.94-10zm64.571 10h-23v-20h23zm97-235h17v156h-17zm29 155.787v-154.936a51.923 51.923 0 0 1 46 51.363v52.21a51.923 51.923 0 0 1 -46 51.363zm55.729-35.162a63.739 63.739 0 0 0 2.271-16.2v-52.21a63.739 63.739 0 0 0 -2.271-16.2 49.413 49.413 0 0 1 0 84.612z",
    fill: "#f86f4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 296.106a6 6 0 0 0 -6 6v75.807a6 6 0 0 0 12 0v-75.807a6 6 0 0 0 -6-6z",
    fill: "#f86f4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 270.892a6 6 0 0 0 -6 6v4.834a6 6 0 0 0 12 0v-4.834a6 6 0 0 0 -6-6z",
    fill: "#f86f4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1);
export default __webpack_public_path__ + "static/media/download (1).c9a92935fe443b745099bc7537e7bd53.svg";
export { ForwardRef as ReactComponent };